module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_WestHamUtd.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_WestHamUtd.png
// module id = 2198
// module chunks = 4